import React from "react";
import { Link } from "react-router-dom";

const Breadcrumb = ({ title }) => {
  return (
    <div className='breadcrumb py-16 bg-white'>
      <div className='container container-lg'>
        <ul className='flex-align gap-8 flex-wrap'>
          <li className='text-sm'>
            <Link
              to='/'
              className='text-gray-500 flex-align gap-8 hover-text-main-600 transition-2'
            >
              <i className='ph ph-house' />
              Home
            </Link>
          </li>
          <li className='flex-align text-gray-400'>
            <i className='ph ph-caret-right text-xs' />
          </li>
          <li className='text-sm text-gray-900 fw-medium'> {title} </li>
        </ul>
      </div>
    </div>
  );
};

export default Breadcrumb;
